var render = function render(){
  var _vm$config;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.setStyle,
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.isRaftStyling ? [(_vm$config = _vm.config) !== null && _vm$config !== void 0 && _vm$config.isB4 ? _c('div', {
    staticClass: "loading-throbber"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  })], 1) : _c('div', [_c('img', {
    attrs: {
      "src": "/sites/all/modules/hide_submit/images/squares.gif",
      "alt": "loading"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.busyText))])] : [_c('div', {
    staticClass: "loading-spinner-container"
  }, [_c('p', [_vm._v(_vm._s(_vm.busyText))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  })])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }